import dayjs from 'dayjs';
import { useLocation } from 'react-router-dom';
import Model from '../models/model';
import consts from '../consts';
import util from '../util';
import { dataStore } from '../Store';
import { MonitoringStatusCell } from './CycleTable';

const isparametric = () => {
	const { auth } = dataStore.getState()
	const loadRelease = auth?.tags?.LoadReleaseId;
	return loadRelease === consts.LoadReleaseType.Parametric;
}

const pathname = '/incubatorcycledetailform';
const { renderBIResultIcon, renderCIResultIcon, renderAttachmentButton, renderBICIEditButton } = util;
const isParametric = isparametric();
const checkIsNotParametric = () => !isparametric()

const RenderAttachmentButton = ({ row }) => {
	const location = useLocation();
	return renderAttachmentButton(row, true, pathname, location)
}
const RenderBICIEditButton = ({ row }) => {
	const location = useLocation();
	return renderBICIEditButton(row, pathname, location);
}
const RenderCIResultIcon = ({ row }) => {
	const location = useLocation();
	return renderCIResultIcon(row, 'CIResultIcon', pathname, location);
}
const RenderBIResultIcon = ({ row }) => {
	const location = useLocation();
	return renderBIResultIcon(row, pathname, location)
}
export const model = new Model({
	// name: 'Cycle',
	name: "SterilizerCycle", 
	defaultSort: 'CycleStart DESC',
	currentUrl: window.location.origin + window.location.pathname,
	disableExport: ({ location }) => ['/incubatorcycledetailform'].includes(location.pathname),
	disableFiltering: ({ location }) => ['/incubatorcycledetailform'].includes(location.pathname),
	disableColumnSelector: ({ location }) => ['/incubatorcycledetailform'].includes(location.pathname),
	disableDelete: true,
	disableAdd: true,
	headerFilter: false,
	idProperty: 'SterilizerCycleId',
	formTitleField: 'SterilizerCycleId',
	title: 'Sterilizer Cycle',
	showGridRefreshBtn: true,
	headerFilterProps: {
		className: 'HeaderFilterForm'
	},
	columns: [
		{ header: 'CycleName', field: 'CycleName', width: 150 },
		{ header: 'CycleCount', field: 'CycleCount', width: 150, type: 'number', align: 'right', headerAlign:'right', valueFormatter: (value) => value?.toString().replace(/,/g, '') },
		{ header: 'SterCycleStatus', field: 'CycleStatus', width: 150 },
		{ header: 'CycleStartDateTime', field: 'CycleStart', width: 200, type: 'dateTime' },
		{ field: 'MonitoringStatus', header: "ProcessMonitoring", width: 200, renderCell: MonitoringStatusCell, isNotExportField: true, excludeOnGrid: !isParametric },
		{ field: 'OperatorName', header: "OperatorName", width: 200, renderCell: RenderBICIEditButton, align: 'right' },
		{ header: 'Load', field: 'LoadNumber', width: 200},
		{ field: 'BIResult', header: 'BIResult', width: 120, type: 'int', renderCell: RenderBIResultIcon, excludeOnGrid: isParametric, isNotExportField: true , align:'right', headerAlign:'right' },
		{ field: 'CIResult', header: 'CIResult', width: 85, type: 'int', renderCell: RenderCIResultIcon, excludeOnGrid: isParametric, isNotExportField: true , align:'right', headerAlign:'right' },
		{ field: 'AttachFile', header: "AttachFile", width: 150, renderCell: RenderAttachmentButton, filterable: false, isNotExportField: true },
		{ field: 'ErrorDescription', header: "AlarmDescription", width: 150 },
		{ field: 'ReviewStatus', header: "ReviewStatus", width: 150, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewComment', header: "Comment", width: 150, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewedDate', header: "ApprovedOn", width: 150, type: 'dateTime', isLocal: true, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewedBy', header: "ApprovedBy", width: 150, excludeOnGrid: checkIsNotParametric },
		{
			field: 'startDate',
			header: 'Start Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			filterable: false,
			maxDate: ({ formik }) => (formik.values.endDate ? dayjs(formik.values.endDate) : undefined),
			hidden: true
		},
		{
			field: 'endDate',
			header: 'End Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			minDate: ({ formik }) => (formik.values.startDate ? dayjs(formik.values.startDate) : undefined),
			hidden: true
		}
	]
});
export const VhpSterilizerTable = model;
export default model.createFormBase();